import { can } from "../libs/permissions"

export const canPermission = {
  mounted(el: any, binding: any) {
    if (!can(binding.value)) {
      el.parentNode.removeChild(el)
    }
  },
}
